import { memo } from "react";
import { View } from "react-native";
import RoundedButton from "src/components/RoundedButton";
import UploadAssetPrompt from "src/components/UploadAssetPrompt";
import IconAddPhoto from "src/icons/IconAddPhoto";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import { EditCoverUploadTabConfig } from "src/screens/(internal)/EditCoverGalleryModal/types";
import UploadAreaDisplay from "./components/UploadAreaDisplay";

const EditCoverUploadContent = ({ config }: { config: EditCoverUploadTabConfig }) => {
	const selectCover = useEditCoverGalleryStore((state) => state.selectCover);

	return (
		<View
			style={{
				flex: 1,
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<UploadAssetPrompt
				allowsMultipleSelection={false}
				renderChildren={({ promptUpload, loading }) => (
					<RoundedButton
						Icon={IconAddPhoto}
						onPress={promptUpload}
						sizeVariant="Large"
						loading={loading}
					>
						Upload your own
					</RoundedButton>
				)}
				webFileDropArea={{
					render: UploadAreaDisplay,
				}}
				onNativeUpload={(files) => {
					const firstFile = files[0];
					if (!firstFile) return;
					selectCover({
						variant: "Upload",
						config,
						url: firstFile.uri,
					});
				}}
				onWebUpload={(files) => {
					const firstFile = files[0];
					if (!firstFile) return;
					selectCover({
						variant: "Upload",
						config,
						url: URL.createObjectURL(firstFile),
						file: firstFile,
					});
				}}
			/>
		</View>
	);
};
export default memo(EditCoverUploadContent);
